(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hero-video-controls]').forEach(function (controls) {
    var hero = controls.closest('.hero');
    var videos = hero.querySelectorAll('video');
    var playBtn = controls.querySelector('.hero__video-btn--play');
    var pauseBtn = controls.querySelector('.hero__video-btn--pause');

    pauseBtn.addEventListener('click', function () {
      videos.forEach(function (v) { v.pause(); });
      pauseBtn.style.display = 'none';
      playBtn.style.display = '';
    });

    playBtn.addEventListener('click', function () {
      videos.forEach(function (v) { v.play(); });
      playBtn.style.display = 'none';
      pauseBtn.style.display = '';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
